import React, { useState, useEffect, useRef } from 'react';
import { gql, useQuery, useLazyQuery, useMutation, useApolloClient } from '@apollo/client';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import MenuItem from '@material-ui/core/MenuItem';
import Modal from '@material-ui/core/Modal';
import Select from '@material-ui/core/Select';
import Typography from '@material-ui/core/Typography';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import DeleteIcon from '@material-ui/icons/Delete';
import Pagination from '@material-ui/lab/Pagination';
import PaginationItem from '@material-ui/lab/PaginationItem';
import Skeleton from '@material-ui/lab/Skeleton';
import SpeedDial from '@material-ui/lab/SpeedDial';
import SpeedDialIcon from '@material-ui/lab/SpeedDialIcon';
import SpeedDialAction from '@material-ui/lab/SpeedDialAction';
import MUIDataTable from 'mui-datatables';
import { useIntl } from 'react-intl';
import { Link, useHistory } from 'react-router-dom';
import SwipeToDelete from 'react-swipe-to-delete-ios';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import { No_Record_String } from '../util/constants.js';

// TODO: The following code snippet is required for the next release
/* import Drawer from '@material-ui/core/Drawer';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField'; */

// TODO: The following code snippet is required for the next release
/* import SaveIcon from '@material-ui/icons/Save';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import ListIcon from '@material-ui/icons/List'; */

// TODO: The following code snippet is required for the next release
/* import CardholderSearch from '../components/CardholderSearch';

import FilterMenuIcon from '../icons/FilterMenuIcon';
import FilterOffIcon from '../icons/FilterOffIcon'; */

// TODO: The following code snippet is required for the next release
/* import { save as saveButton, clear as clearButton, add as addButton } from '../util/commonText'; */

// import Snackbar from '@material-ui/core/Snackbar';
// import MuiAlert from '@material-ui/lab/Alert';

import ButtonHeader from '../components/ButtonHeader.jsx';
import CardholderCard from '../components/CardholderCard.jsx';
import CardholderDelete from '../components/CardholderDelete.jsx';
import FiltersMenu from '../components/FiltersMenu.jsx';
import { formatActivityTime } from '../util/dateHelpers';
import {
  GET_CARDHOLDERS,
  GET_CARDHOLDERSFIELDS,
  GET_USER_CONFIG,
  GET_USER_CONFIG_ID,
  ADD_USER_CONFIG,
  UPDATE_USER_CONFIG,
  REMOVE_USER_CONFIG,
} from '../util/schema';
import { useCookies } from 'react-cookie';
import getNameFromToken from '../util/jwtToken';

const drawerWidth = 500;

const useStyles = makeStyles((theme) => ({
  flexGrow: {
    flexGrow: 1,
  },
  showFiltersButton: {
    borderRadius: 0,
    height: theme.spacing(4),
    marginTop: theme.spacing(1),
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.header.main,
    float: 'right',
  },
  noCardholders: {
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  footer: {
    display: 'flex',
    alignContent: 'center',
    marginTop: theme.spacing(2),
    marginLeft: theme.spacing(1),
  },
  drawer: {
    width: drawerWidth,
    padding: theme.spacing(2),
  },
  drawerPaper: {
    width: drawerWidth,
    padding: theme.spacing(2),
  },
  drawerHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    marginLeft: theme.spacing(1),
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  formControlHalf: {
    margin: theme.spacing(1),
    minWidth: 120,
    maxWidth: '50%',
  },
  filterButtons: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  filterButton: {
    margin: theme.spacing(1),
  },
  lowerButtons: {
    marginTop: 'auto',
    display: 'flex',
    justifyContent: 'space-between',
  },
  shadow: {
    boxShadow:
      '0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12)',
  },
  cardView: {
    display: 'inline-flex',
  },
  controls: {
    display: 'flex',
    alignItems: 'center',
  },
  pageOf: {
    marginRight: '30px',
    marginLeft: '30px',
    display: 'contents',
  },
  pageOfSelect: {
    marginLeft: '10px',
  },
  root: {
    // height: 380,
    // transform: 'translateZ(0px)',
    flexGrow: 1,
    // position: 'fixed',
  },
  speedDial: {
    position: 'fixed',
    bottom: theme.spacing(3),
    right: theme.spacing(2),
  },
  loading: {
    margin: 'auto',
  },
}));

const CardholdersPage = ({ apiToken, filters }) => {
  const history = useHistory();
  const intl = useIntl();
  const classes = useStyles();
  const theme = useTheme();
  const [count, setCount] = useState();
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [cardholderToDelete, setCardholderToDelete] = useState({});
  const [savedFilters, setSavedFilters] = useState([]);
  const [text, setText] = useState('');
  const [pageSize, setPageSize] = useState(15);
  const [totalCount, setTotalCount] = useState(1);
  const [gridDisplay, setDisplay] = useState(false);
  const ref = useRef();
  const matches = useMediaQuery('(max-width:600px)');
  const [postList, setPostList] = useState();
  const [cardstoSkip, setcardstoSkip] = useState();
  const [page, setPage] = useState(1);
  const loader = useRef(null);
  const [newlength, setNewlength] = useState(1);
  const [availableFields, setavailableFields] = useState([]);
  const [filtermenuopen, setfiltersmenuopen] = useState(false);
  const [cookies, setCookie, removeCookie] = useCookies(['name']);
  const [userName, setuserName] = useState(cookies.username);
  const [UserID, setUserID] = useState(1);
  const [userConfigInput, setuserConfigInput] = useState();
  const [newDataFlag, setnewDataFlag] = useState(false);
  const [userConfigValues, setuserConfigValues] = useState([]);
  const [queryFilters, setQueryFilters] = useState([]);
  const [cardCount, setCardCount] = useState(0);
  const Norecord = No_Record_String;
  const [sloading, setLoading] = useState(false);

  const sleep = (milliseconds) => {
    return new Promise((resolve) => setTimeout(resolve, milliseconds));
  };

  const client = useApolloClient();

  async function runQuery(Filters, MutableFilters) {
    setLoading(true);

    const getCardholders = await client.query({
      query: GET_CARDHOLDERS,
      variables: { first: pageSize, skip: (pageNumber - 1) * pageSize },
      onCompleted: queryFiltered,
      onError: queryError,
    });

    setCount(
      getCardholders.data ? Math.ceil(getCardholders.data.cardholders.totalCount / pageSize) : count
    );
    setTotalCount(getCardholders.data.cardholders.totalCount);
    let preList = getCardholders.data.cardholders.edges;

    sleep(200).then(() => {
      const thisList = postListFilter(preList, Filters);
      setPostList(thisList);
    });

    setLoading(false);
  }

  async function runQueryFields() {
    setLoading(true);

    const getCardholderFields = await client.query({
      query: GET_CARDHOLDERSFIELDS,
      onError: queryError,
    });

    const fieldlist = getCardholderFields.data.cardholderFieldConfig.fieldRows.map((field) => {
      return {
        label: field.fields[0].label,
        id: field.fields[0].id,
        filter: 'Filter...',
        checked: false,
      };
    });
    setavailableFields(fieldlist);

    setLoading(false);
    return fieldlist;
  }

  useEffect(() => {
    const options = {
      root: null,
      rootMargin: '20px',
      threshold: 1.0,
    };
    const observer = new IntersectionObserver(handleObserver, options);
    if (loader.current) {
      observer.observe(loader.current);
    }
    let ClientName = getNameFromToken(apiToken);
    setuserName(ClientName);

    if (filters && filters.length > 0) {
      const Filters = [];
      Filters.push(filters);
      setuserConfigValues(Filters);
      let Fields;
      runQueryFields().then(function (result) {
        Fields = result;
        sleep(200).then(() => {
          setFilterValues(Filters, Fields);
        });
      });
    } else {
      fetchUserConfig();
    }
  }, []);

  useEffect(() => {
    if (page !== 1) {
      if (!cardstoSkip) {
        setcardstoSkip(15);
      } else {
        const somenumber = cardstoSkip + 15;
        setcardstoSkip(somenumber);
      }
      fetchLimited();
    }
  }, [page]);

  let initial = true;
  const handleObserver = (entities) => {
    const target = entities[0];
    if (target.isIntersecting) {
      if (!initial) {
        setPage((page) => page + 1);
      } else {
        initial = false;
      }
    }
  };

  const [open, setOpen] = React.useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleFABClose = () => {
    setOpen(false);
  };

  const queryCompletedFields = (data) => {
    const fieldlist = data.cardholderFieldConfig.fieldRows.map((field) => {
      return {
        label: field.fields[0].label,
        id: field.fields[0].id,
        filter: 'Filter...',
        checked: false,
      };
    });
    setavailableFields(fieldlist);
  };

  const query = new URLSearchParams(window.location.search);
  const pageNumber = parseInt(query.get('page') || '1') || 1;

  const setFilterValues = (Filters, Fields) => {
    const filters = Filters;
    if (filters.length > 0) {
      const MutableFilters = [];
      if (filters) {
        for (let i = 0; i < Fields.length; i += 1) {
          const elementi = Fields[i];
          let notfound = true;
          filters[0].forEach((field) => {
            if (elementi.id === field.id) {
              const newElement = {
                label: elementi.label,
                id: field.id,
                filter: field.filter,
                checked: field.checked,
              };
              MutableFilters.push(newElement);
              notfound = false;
            }
          });
          if (notfound) {
            MutableFilters.push(elementi);
          }
        }
        setSavedFilters(MutableFilters);
      }
    }
    sleep(100).then(() => {
      runQuery(Filters);
    });
  };

  const postListFilter = (preList, Filters) => {
    const filters = Filters;
    if (filters && filters.length > 0 && preList) {
      const filtered = filters.filter((filter) => {
        if (filter[0].checked === true) {
          return filter;
        }
      });
      const completed = [];
      filtered.forEach((element) => {
        const filtername = element[0].id;
        preList.filter((cardholder) => {
          if (cardholder[filtername] === element[0].filter) {
            completed.push(cardholder);
          }
        });
      });
      preList = completed;
      setCardCount(completed.length);
    }
    return preList;
  };

  const queryFiltered = (data) => {
    setCount(data ? Math.ceil(data.cardholders.totalCount / pageSize) : count);
    setTotalCount(data.cardholders.totalCount);
    let preList = data.cardholders.edges;

    sleep(200).then(() => {
      const thisList = postListFilter(preList);
      setPostList(thisList);
    });
  };

  const queryCompleted = (data) => {
    setCount(data ? Math.ceil(data.cardholders.totalCount / pageSize) : count);
    setTotalCount(data.cardholders.totalCount);
    let preList = data.cardholders.edges;
    preList = data.cardholders.edges;
    setCardCount(data.cardholders.edges.length);
    setPostList(preList);
  };

  const queryError = ({ graphQLErrors, networkError }) => {
    console.log(graphQLErrors);
    console.log(networkError);
  };

  const { data, loading, error, refetch } = useQuery(GET_CARDHOLDERS, {
    variables: { first: pageSize, skip: (pageNumber - 1) * pageSize },
    notifyOnNetworkStatusChange: true,
    onCompleted: queryCompleted,
    onError: queryError,
  });

  const {
    data: dataFields,
    loading: loadingFields,
    error: errorFields,
    refetch: refetchField,
  } = useQuery(GET_CARDHOLDERSFIELDS, {
    notifyOnNetworkStatusChange: true,
    onCompleted: queryCompletedFields,
    onError: queryError,
  });

  const queryCompletedfetch = (newData) => {
    setNewlength(newData.cardholders.edges.length);
    const newList = postList.concat(newData.cardholders.edges);
    setPostList(newList);
  };

  const [fetchLimited, { data: newData, loading: newDataLoading, error: newError }] = useLazyQuery(
    GET_CARDHOLDERS,
    {
      variables: { first: pageSize, skip: cardstoSkip },
      notifyOnNetworkStatusChange: true,
      onCompleted: queryCompletedfetch,
      onError: queryError,
    }
  );

  const queryUserConfig = (data) => {
    if (data == null) {
      setnewDataFlag(true);
    } else {
      setUserID(data.userConfigData.User_ID);
      setnewDataFlag(false);
      const obj = JSON.parse(data.userConfigData.Settings);
      if (obj.Value) {
        const Values = obj.Value;
        if (typeof Values === 'object') {
          if (Values.filters && Values.filters.length > 0) {
            let filtersQ = Values.filters;
            const queryF = [];
            if (typeof filtersQ !== 'object') {
              filtersQ = JSON.parse(Values.filters);
            }
            queryF.push(filtersQ);
            setQueryFilters(queryF);
            setuserConfigValues(queryF);
            let Fields;
            runQueryFields().then(function (result) {
              Fields = result;
              sleep(200).then(() => {
                setFilterValues(queryF, Fields);
              });
            });
          } else {
            return;
          }
        }
      } else {
        const Values = JSON.parse(obj.Value);
        if (Values.filters) {
          const queryF = Values.filters;
          setQueryFilters(queryF);
          setuserConfigValues(queryF);
          let Fields;
          runQueryFields().then(function (result) {
            Fields = result;
            sleep(200).then(() => {
              setFilterValues(queryF, Fields);
            });
          });
        }
      }

      return obj;
    }
  };

  const queryErrorUserConfig = ({ graphQLErrors, networkError }) => {
    console.log(graphQLErrors);
    console.log(networkError);
    setnewDataFlag(true);
  };

  const [
    fetchUserConfig,
    { data: userData, loading: userDataLoading, error: userDataError, fetchMore },
  ] = useLazyQuery(GET_USER_CONFIG, {
    variables: { userconfigName: userName },
    notifyOnNetworkStatusChange: true,
    onCompleted: queryUserConfig,
    onError: queryErrorUserConfig,
  });

  const [
    addUserConfig,
    { data: userDataadd, loading: userDataLoadingadd, error: userDataErroradd },
  ] = useMutation(ADD_USER_CONFIG, {
    notifyOnNetworkStatusChange: true,
    onError: queryError,
  });
  const [
    updateUserConfig,
    { data: userDataupdate, loading: userDataLoadingupdate, error: userDataErrorupdate },
  ] = useMutation(UPDATE_USER_CONFIG, {
    notifyOnNetworkStatusChange: true,
    onError: queryError,
  });

  const [
    removeUserConfig,
    { data: userDataRemove, loading: userDataloadingR, error: userDataErrorR },
  ] = useMutation(REMOVE_USER_CONFIG, {
    notifyOnNetworkStatusChange: true,
    onError: queryError,
  });

  const handleClose = () => {
    setShowDeleteDialog(false);
    runQuery();
  };

  const handleDelete = ({ cardholder }) => {
    setCardholderToDelete(cardholder);
    setShowDeleteDialog(true);
  };
  const handleChangePageSize = (event) => {
    setPageSize(event.target.value);
  };

  const buttonList = [
    {
      name: intl.formatMessage({
        id: 'cardholders.new',
        description: 'cardholders new cardholder',
        defaultMessage: 'New Cardholder',
      }),
      action: () => {
        history.push('/cardholders/new');
      },
    },
    {
      name: intl.formatMessage({
        id: 'cardholders.filter',
        description: 'filter cardholder directory',
        defaultMessage: 'Filter',
      }),
      action: () => {
        setfiltersmenuopen(true);
      },
      icon: <FilterAltIcon />,
    },
    // TODO: The following code snippet is required for the next release
    /* {
      name: intl.formatMessage({
        id: 'cardholders.accessGroupUtility',
        description: 'cardholders access group',
        defaultMessage: 'Access Group Utility',
      }),
      action: () => {},
    },
    {
      name: intl.formatMessage({
        id: 'cardholders.bulkutility',
        description: 'cardholders bulk',
        defaultMessage: 'Bulk Utility',
      }),
      action: () => {},
    }, */
  ];

  const [hidden, setHidden] = React.useState(false);

  const handleVisibility = () => {
    setHidden((prevHidden) => !prevHidden);
  };

  const columns = [
    'First Name',
    'Last Name',
    // 'Primary Card Number',
    // 'Active Record',
    'Employee Number',
    'Last Active',
  ];

  const options = {
    filterType: 'checkbox',
  };

  const handleTouchStart = (e, cardholder) => {
    setCardholderToDelete(cardholder);
  };

  const handleDeleteSwipe = (cardholder) => {
    setShowDeleteDialog(true);
  };

  const handleCloseFilters = (event, passedFilters) => {
    const currentTheme = theme.palette.type === 'dark' ? true : false;
    if (passedFilters && passedFilters.length > 0) {
      if (!Object.is(passedFilters, savedFilters)) {
        const checkedFilters = [];
        passedFilters.forEach((element) => {
          if (element.checked) {
            checkedFilters.push(element);
          }
        });
        if (checkedFilters.length > 0) {
          let input = {
            settings: {
              darkmode: currentTheme,
              filters: JSON.stringify(checkedFilters),
            },
          };
          if (newDataFlag) {
            addUserConfig({ variables: { userConfigInput: input } });
          } else {
            updateUserConfig({ variables: { userConfigInput: input } });
          }
        }
      }
      setfiltersmenuopen(false);
      sleep(500).then(() => {
        window.location.reload();
      });
    } else {
      let input = {
        settings: {
          darkmode: currentTheme,
        },
      };
      updateUserConfig({ variables: { userConfigInput: input } });
      setuserConfigValues([]);
      setSavedFilters([]);
      setfiltersmenuopen(false);
      sleep(500).then(() => {
        window.location.reload();
      });
    }
  };

  return (
    <>
      <ButtonHeader
        title={intl.formatMessage({
          id: 'cardholders.title',
          description: 'cardholders directory title',
          defaultMessage: 'Cardholder Directory',
        })}
        buttonList={buttonList}
      />
      <FiltersMenu
        savedFilters={savedFilters.length > 0 ? savedFilters : null}
        availableFields={availableFields}
        filtermenuopen={filtermenuopen}
        handleCloseFilters={handleCloseFilters}
      />
      <br />
      {!gridDisplay && (
        <Grid container spacing={2} className={classes.cardView}>
          {loading &&
            [...Array(15).keys()].map((i) => (
              <Grid item xs={12} md={6} lg={4} key={i}>
                <CardholderCard loading cardholder={{}} />
              </Grid>
            ))}
          {!loading &&
            !error &&
            (cardCount > 0 ? (
              text ? (
                data.cardholders.edges
                  .filter(
                    (cardholder) =>
                      cardholder.firstName.includes(text) ||
                      cardholder.lastName.includes(text) ||
                      cardholder.title?.includes(text)
                  )
                  .map((cardholder) => (
                    <Grid item xs={12} md={6} lg={4} key={cardholder.id}>
                      <CardholderCard cardholder={cardholder} handleDelete={handleDelete} />
                    </Grid>
                  ))
              ) : (
                postList &&
                postList.map((cardholder) => (
                  <Grid item xs={12} md={6} lg={4} key={cardholder.id}>
                    {matches ? (
                      <div
                        onTouchStart={(e) => {
                          handleTouchStart(e, cardholder);
                        }}
                      >
                        <SwipeToDelete
                          onDelete={(e) => {
                            handleDeleteSwipe(cardholder);
                          }} // required
                          height={105} // required
                          // optional
                          transitionDuration={200} // default
                          deleteWidth={75} // default
                          deleteColor="rgba(252, 58, 48, 1.00)" // default
                          deleteText="Delete" // default
                          deleteComponent={<DeleteIcon />} // not default
                          disabled={false} // default
                          rtl={false} // default
                        >
                          <CardholderCard cardholder={cardholder} handleDelete={handleDelete} />
                        </SwipeToDelete>
                      </div>
                    ) : (
                      <CardholderCard cardholder={cardholder} handleDelete={handleDelete} />
                    )}
                  </Grid>
                ))
              )
            ) : (
              <>
                <Typography style={{ color: 'red' }}>{No_Record_String}</Typography>
              </>
            ))}
          {
            <>
              <div
                className={classes.loading}
                ref={loader}
                style={!matches ? { display: 'none' } : {}}
              >
                <>{newlength ? <CircularProgress color="secondary" /> : <></>}</>
              </div>
            </>
          }
        </Grid>
      )}
      <div className={classes.root}>
        <SpeedDial
          ariaLabel="SpeedDial openIcon example"
          className={classes.speedDial}
          hidden={!matches ? true : false}
          icon={<SpeedDialIcon />}
          onClose={handleFABClose}
          onOpen={handleOpen}
          open={open}
        >
          <SpeedDialAction
            tooltipTitle={'New Cardholder'}
            key={'New Cardholder'}
            tooltipOpen
            icon={<AddCircleOutlineIcon></AddCircleOutlineIcon>}
            onClick={() => history.push('/cardholders/new')}
          ></SpeedDialAction>
          {/* TO DO add more speed dial options  */}
          {/* {actions.map((action) => (
          <SpeedDialAction
            key={action.name}
            icon={action.icon}
            tooltipTitle={action.name}
            onClick={handleClose}
          />
        ))} */}
        </SpeedDial>
      </div>
      <Modal open={showDeleteDialog} onClose={handleClose}>
        <div>
          <CardholderDelete
            cardholder={cardholderToDelete}
            onClose={handleClose}
            onDelete={runQuery}
          />
        </div>
      </Modal>
      {!loading && !error && data.cardholders.totalCount <= 0 && (
        <div className={classes.noCardholders}>
          <Typography>
            {/* TODO: add link destination or convert to button  */}
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            No cardholder records exist. <Link href="#">Add one?</Link>
          </Typography>
        </div>
      )}
      {!gridDisplay && !matches && (
        <div className={classes.footer}>
          {loading && <Skeleton variant="text" width={theme.spacing(12)} />}
          {!loading &&
            !error &&
            data.cardholders.totalCount > 0 &&
            (text ? (
              <>
                <Typography>
                  {cardCount.length
                    ? `${cardCount.length ? 1 : 0} - ${cardCount.length} of ${cardCount.length}`
                    : 'No Results Found '}
                  {' ' + cardCount.length}
                </Typography>
                <div className={classes.flexGrow} />
                <Pagination
                  count={cardCount.length < 15 ? 1 : count}
                  color="secondary"
                  shape="rounded"
                  page={cardCount.length ? pageNumber : 1}
                  renderItem={(item) => (
                    <PaginationItem
                      component={Link}
                      to={`/cardholders${item.page === 1 ? '' : `?page=${item.page}`}`}
                      {...item}
                    />
                  )}
                />
              </>
            ) : (
              <>
                <div className={classes.flexGrow} />
                {cardCount <= 0 ? (
                  <></>
                ) : (
                  <div className={classes.controls}>
                    <Typography>Rows per page:</Typography>
                    <Select
                      className={classes.pageOfSelect}
                      labelId="demo-simple-select-label"
                      value={pageSize}
                      disableUnderline={true}
                      onChange={handleChangePageSize}
                    >
                      {[15, 20, 25, 30, 35, 40, 45].map((item, index) => (
                        <MenuItem value={item} key={index}>
                          {item}
                        </MenuItem>
                      ))}
                    </Select>
                    <Typography className={classes.pageOf}>
                      {`${(pageNumber - 1) * pageSize + 1} - ${
                        (pageNumber - 1) * pageSize + data.cardholders.edges.length
                      } of ${data.cardholders.totalCount}`}
                    </Typography>
                    <Pagination
                      count={count}
                      color="secondary"
                      shape="rounded"
                      page={pageNumber}
                      showFirstButton
                      showLastButton
                      renderItem={(item) => (
                        <PaginationItem
                          component={Link}
                          to={`/cardholders${item.page === 1 ? '' : `?page=${item.page}`}`}
                          {...item}
                        />
                      )}
                    />
                  </div>
                )}
              </>
            ))}
        </div>
      )}
      {gridDisplay && !loading && error && data.cardholders.totalCount > 0 && (
        <MUIDataTable
          title="Cardholders"
          data={data.cardholders.edges.map((cardholder) => [
            cardholder.firstName,
            cardholder.lastName,
            cardholder.employeeNumber,
            cardholder.lastActivity
              ? 'Last active ' + formatActivityTime(cardholder.lastActivity, false)
              : 'No Activity',
          ])}
          columns={columns}
          options={options}
          // open={gridDisplay}
          //     onClose={() => {
          //       setDisplay(false);
          // }}
        />
      )}
    </>
  );
};

export default CardholdersPage;
